import http from '@/core/http';
import { DOMAIN_SYSTEM_ENUM } from '@toy/utils';
import {
  IGetCanalErrorLogsReq,
  IGetCanalErrorLogsRes,
  IGetGoodsListReq,
  ISyncGoodsDataReq,
  ICategoryListRes,
  IGetSupplierListReq,
  IGetSupplierListRes,
  IGetEsGoodsListRes,
  IGetEsGoodsListReq,
  IGetGoodsListRes,
} from './type.d';

/**
 * canal日志 - 列表
 */
export function getCanalErrorLogs(data: IGetCanalErrorLogsReq) {
  return http.get<IGetCanalErrorLogsRes>({
    url: '/product/web/v1/canal-msg-error-log/page',
    isCancelDuplicateUrlRequests: true,
    params: data,
  });
}

/**
 * 同步canal日志
 */
export function syncCanalErrorLog(data: {
  logId: number|string;
}) {
  return http.post({
    url: `/product/web/v1/canal-msg-error-log/${data.logId}`,
    isCancelDuplicateUrlRequests: true,
    loading: true,
  });
}
/**
 * 获取商品数据列表
 */
export function getGoodsList(data: IGetGoodsListReq) {
  return http.post<IGetGoodsListRes>({
    url: '/product/web/v1/product/ops/product/page',
    isCancelDuplicateUrlRequests: true,
    loading: true,
    data,
  });
}

/**
 * 同步商品数据
 */
export function syncGoodsData(data: ISyncGoodsDataReq) {
  return http.post({
    url: '/product/web/v1/product/ops/product/sync',
    isCancelDuplicateUrlRequests: true,
    loading: true,
    data,
  });
}

/**
 * 同步全部商品数据
 */
export function syncAllGoodsData() {
  return http.post({
    url: '/product/web/v1/product/ops/product/syncAll',
    isCancelDuplicateUrlRequests: true,
    loading: true,
  });
}
/**
 * 批量删除商品数据
 */
export function deleteGoodsData(data: {
  spuIds: string[];
}) {
  return http.post({
    url: '/product/web/v1/product/ops/product/del',
    isCancelDuplicateUrlRequests: true,
    loading: true,
    data,
  });
}

// 列表查询时，末级无关联商品不显示，新增时则显示，根据参数区别 是否关联商品, true代表关联。 false代表未关联
// 获取商品类目（请求全部），无分页
export const getProductCategoryListAll = () => {
  const url = '/product/web/v1/category/product-category-all';
  return http.get<ICategoryListRes[]>({
    url,
    loading: false,
  });
};
// 获取商品类目 无分页，区别于类目列表接口，分级请求
export const getProductCategoryList = (params: { parentId: string; refType?: number; }) => {
  const url = '/product/web/v1/category/product-categories';
  return http.get<ICategoryListRes[]>({
    url,
    params,
    loading: false,
  });
};

// 获取供应商列表；
export const getSupplierList = (params: IGetSupplierListReq) => {
  const url = '/cuckoo/web/v1/supplier/page';
  return http.post<IGetSupplierListRes>({
    server: DOMAIN_SYSTEM_ENUM.TIANGONG,
    url,
    data: params,
    isCancelDuplicateUrlRequests: true,
  });
};

// 获取ES商品列表
export const getEsGoodsList = (data: IGetEsGoodsListReq) => {
  return http.post<IGetEsGoodsListRes>({
    url: '/product/web/v1/ops/es-spu/page',
    isCancelDuplicateUrlRequests: true,
    loading: true,
    data,
  });
};
// 删除ES商品
export const delEsGoods = (data: string[]) => {
  return http.post({
    url: '/product/web/v1/ops/es-spu/delete',
    isCancelDuplicateUrlRequests: true,
    loading: true,
    data,
  });
};
/**
 * 同步辅料商品城市数据
 */
export const syncProductCity = (data:{spuIds: string[];}) => {
  return http.post({
    url: '/product/web/v1/product/ops/city/sync',
    isCancelDuplicateUrlRequests: true,
    loading: true,
    data,
  });
};
